const SystemManagement = [
    {
        path: "/wcp/system/management/user",
        name: "User",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u7528\u6237\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/user/User"),
        }
    },
    {
        path: "/wcp/system/management/user/modify",
        name: "UserModify",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u7528\u6237\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/user/UserModify"),
        }
    },
    {
        path: "/wcp/system/management/role",
        name: "Role",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u89d2\u8272\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/role/Role"),
        }
    },
    {
        path: "/wcp/system/management/role/modify",
        name: "RoleModify",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u89d2\u8272\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/role/RoleModify"),
        }
    },
    {
        path: "/wcp/system/management/permission",
        name: "Permission",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u6743\u9650\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/permission/Permission"),
        }
    },
    {
        path: "/wcp/system/management/permission/modify",
        name: "PermissionModify",
        meta: { title: '\u7cfb\u7edf\u7ba1\u7406-\u6743\u9650\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/system-management/navigation/NavigationBar"),
            main: () => import("@/views/system-management/permission/PermissionModify"),
        }
    }
    
]

export default SystemManagement;


// WEBPACK FOOTER //
// ./src/router/system-management.js